import { render, staticRenderFns } from "./HistoryBlock.vue?vue&type=template&id=28f51993&"
import script from "./HistoryBlock.vue?vue&type=script&lang=ts&"
export * from "./HistoryBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports